var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBeads1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.85,298.19c17.53,0,31.74-14.21,31.74-31.74s-14.21-31.74-31.74-31.74-31.74,14.21-31.74,31.74,14.21,31.74,31.74,31.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.63,221.34c15.71,0,28.45-12.74,28.45-28.45s-12.74-28.45-28.45-28.45-28.45,12.74-28.45,28.45,12.74,28.45,28.45,28.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.36,156.17c13.32,0,24.12-10.8,24.12-24.11s-10.8-24.11-24.12-24.11-24.11,10.8-24.11,24.11,10.8,24.11,24.11,24.11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.4,103.43c11.34,0,20.53-9.19,20.53-20.53s-9.19-20.53-20.53-20.53-20.53,9.19-20.53,20.53,9.19,20.53,20.53,20.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.16,65.97c10.04,0,18.19-8.14,18.19-18.19s-8.14-18.19-18.19-18.19-18.19,8.14-18.19,18.19,8.14,18.19,18.19,18.19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,44.95c7.45,0,13.5-6.04,13.5-13.5s-6.04-13.5-13.5-13.5-13.5,6.04-13.5,13.5,6.04,13.5,13.5,13.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,401.59c-25.53,0-46.23,20.7-46.23,46.23s20.7,46.23,46.23,46.23,46.23-20.7,46.23-46.23-20.7-46.23-46.23-46.23ZM256,435c-7.07,0-12.81,5.75-12.81,12.81,0,4.36-3.54,7.9-7.9,7.9s-7.9-3.54-7.9-7.9c0-15.77,12.84-28.61,28.62-28.61,4.36,0,7.9,3.54,7.9,7.9s-3.54,7.9-7.9,7.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.37,378.5c-22.1,0-40.01,17.92-40.01,40.01s17.91,40.01,40.01,40.01,40.01-17.92,40.01-40.01-17.91-40.01-40.01-40.01ZM160.36,412.17c-3.5,0-6.34,2.85-6.34,6.35,0,4.36-3.54,7.9-7.9,7.9s-7.9-3.54-7.9-7.9c0-12.21,9.93-22.15,22.15-22.15,4.36,0,7.9,3.54,7.9,7.9s-3.54,7.9-7.9,7.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.37,347.8c0-20.09-16.29-36.38-36.38-36.38s-36.38,16.29-36.38,36.38,16.29,36.38,36.38,36.38,36.38-16.29,36.38-36.38ZM105,343.9c-2.15,0-3.89,1.75-3.89,3.9,0,4.36-3.54,7.9-7.9,7.9s-7.9-3.54-7.9-7.9c0-10.86,8.83-19.7,19.69-19.7,4.36,0,7.9,3.54,7.9,7.9s-3.54,7.9-7.9,7.9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.41,266.45c0,17.53,14.21,31.74,31.74,31.74s31.74-14.21,31.74-31.74-14.21-31.74-31.74-31.74-31.74,14.21-31.74,31.74Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.92,192.89c0,15.71,12.74,28.45,28.45,28.45s28.45-12.74,28.45-28.45-12.74-28.45-28.45-28.45-28.45,12.74-28.45,28.45Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 372.64,
    cy: 132.05,
    r: 24.11
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.6,103.43c11.34,0,20.53-9.19,20.53-20.53s-9.19-20.53-20.53-20.53-20.53,9.19-20.53,20.53,9.19,20.53,20.53,20.53Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.84,65.97c10.04,0,18.19-8.14,18.19-18.19s-8.14-18.19-18.19-18.19-18.19,8.14-18.19,18.19,8.14,18.19,18.19,18.19Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.63,378.5c-22.1,0-40.01,17.92-40.01,40.01s17.91,40.01,40.01,40.01,40.01-17.92,40.01-40.01-17.91-40.01-40.01-40.01ZM351.63,412.17c-3.5,0-6.34,2.85-6.34,6.35,0,4.36-3.54,7.9-7.9,7.9s-7.9-3.54-7.9-7.9c0-12.21,9.93-22.15,22.15-22.15,4.36,0,7.9,3.54,7.9,7.9s-3.54,7.9-7.9,7.9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407,311.42c-20.09,0-36.38,16.29-36.38,36.38s16.29,36.38,36.38,36.38,36.38-16.29,36.38-36.38-16.29-36.38-36.38-36.38ZM407,343.9c-2.15,0-3.9,1.75-3.9,3.9,0,4.36-3.54,7.9-7.9,7.9s-7.9-3.54-7.9-7.9c0-10.86,8.84-19.7,19.7-19.7,4.36,0,7.9,3.54,7.9,7.9s-3.54,7.9-7.9,7.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeads1);
export default __webpack_public_path__ + "static/media/icon_beads1.48383029bc8eb91eae8752e26a35812c.svg";
export { ForwardRef as ReactComponent };